const Tokenizer = require("../tokenizer");
class CharacterTokenizer extends Tokenizer {
    value;

    constructor(type, value) {
        super(type);
        this.value = value;
    }

    getToken(text, currentPos) {
        if (this.value === text[currentPos]) {
            return [1, {type: this.type, value: this.value}];
        } else {
            return [0, null];
        }
    }
}

module.exports = CharacterTokenizer;